export default "6f7142416812f3ab.svg"